import React from 'react';
import GetTheAppHero from '../components/get-the-app/GetTheAppHero';
import IOSInstallSteps from '../components/get-the-app/IOSInstallSteps';
import DeviceInstallGuides from '../components/get-the-app/DeviceInstallGuides';
import GetTheAppFeatures from '../components/get-the-app/GetTheAppFeatures';
import GetTheAppDoMore from '../components/get-the-app/GetTheAppDoMore';
import GetTheAppEmailSignup from '../components/get-the-app/GetTheAppEmailSignup';

export default function GetTheAppPage() {
  return (
    <div className="min-h-full bg-[#f5f5f5]">
      <GetTheAppHero />
      <IOSInstallSteps />
      <DeviceInstallGuides />
      <GetTheAppFeatures />
      <GetTheAppDoMore />
      <GetTheAppEmailSignup />
    </div>
  );
}
